import { MedicationFrequency } from "~/common/types";

export const getSelectedMedicationFrequency = (
  selectedFrequencyId: string,
  frequencies?: MedicationFrequency[],
) => frequencies?.find(({ id }) => id === selectedFrequencyId);
